import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  updateNotificationProgressSuccess,
  updateNotificationTaskTotalSuccess,
} from '../../actions/user.actions';

import { AppState } from 'src/app/reducers';
import { Store } from '@ngrx/store';
import { UserBackgroundTask } from '../../models/core.models';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-user-background-task-list',
    templateUrl: './user-background-task-list.component.html',
    styleUrls: ['./user-background-task-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserBackgroundTaskListComponent implements OnInit {
  @Input() userBackgroundTasks: UserBackgroundTask[] = [];

  constructor(
    private userService: UserService,
    private store: Store<AppState>,
  ) {}

  close() {}
  ngOnInit() {
    //itterate over userBackgroundTasks
    //for each key, create a websocket connection
    //onmessage, update the progress bar
    this.userBackgroundTasks.forEach((task) => {});
  }
}
